// Global application configuration
export const APP_CONFIG = {
  // Disable SSE globally to prevent infinite loops
  // This will force all components to use polling instead of SSE
  SSE_ENABLED: false,
  
  // Fallback to polling when SSE is disabled
  POLLING_ENABLED: true,
  POLLING_INTERVAL: 5000, // 5 seconds
  
  // API configuration
  API_BASE_URL: import.meta.env.VITE_API_URL || 'https://web-api-rqa6jhyvwa-uc.a.run.app',
  
  // Development settings
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_PRODUCTION: import.meta.env.PROD,
};

// Export individual config values for convenience
export const { SSE_ENABLED, POLLING_ENABLED, POLLING_INTERVAL, API_BASE_URL } = APP_CONFIG;

